"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles.css");
var _sequencer = require("../../../assets/toggle/sequencer.svg");
var _controller = require("../../../assets/toggle/controller.svg");
var _shadow = require("../../../assets/toggle/shadow.svg");
var _toggle = require("../../../assets/toggle/toggle.svg");
var _react = require("react");
var _sequencerToggleContext = _interopRequireDefault(require("../../../store/sequencer-toggle-context"));
var _RCSequencerManager = _interopRequireDefault(require("../../../utils/RCSequencer/RCSequencerManager"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SequencerToggle = () => {
  const sequencerToggleCtx = (0, _react.useContext)(_sequencerToggleContext.default);
  const toggleSequencer = () => {
    _RCSequencerManager.default.clearSequence();
    sequencerToggleCtx.setSequencerToggle(!sequencerToggleCtx.sequencerToggle);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "sequencer-toggle-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sequencer-toggle-controller-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_controller.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sequencer-toggle-toggle-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "sequencer-toggle-shadow-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "shadow-toggle-div",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shadow.ReactComponent, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "on-toggle-div",
          onClick: toggleSequencer,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggle.ReactComponent, {
            style: {
              visibility: !sequencerToggleCtx.sequencerToggle ? "initial" : "hidden"
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "off-toggle-div",
          onClick: toggleSequencer,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggle.ReactComponent, {
            style: {
              visibility: sequencerToggleCtx.sequencerToggle ? "initial" : "hidden"
            }
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sequencer-toggle-race-track-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sequencer.ReactComponent, {})
    })]
  });
};
var _default = exports.default = SequencerToggle;